import { useMemo } from "react";
import { useRestApiProvider } from "@jugl-web/rest-api";
import { useUserGeneralProfile } from "./useUserGeneralProfile";

export const useBookmarkedAttributes = ({
  entityId,
  userId,
}: {
  entityId: string;
  userId: string;
}) => {
  const { usersApi } = useRestApiProvider();
  const { data: userCustomFields } = usersApi.useGetUserCustomFieldsQuery({
    entityId,
  });

  const { profile } = useUserGeneralProfile({ userId, entityId });

  const bookmarkedAttributes = useMemo(
    () =>
      userCustomFields?.value
        .filter((el) => el.bookmark)
        .sort((a, b) => a.bookmark - b.bookmark),
    [userCustomFields]
  );

  const hasBookmarkedAttributes = useMemo(() => {
    const bookmarkedIds = bookmarkedAttributes?.map((el) => el.id);
    const fieldValues = profile?._user.work_info.filter((el) =>
      bookmarkedIds?.includes(el.key)
    );
    return fieldValues?.some((el) => el.value);
  }, [bookmarkedAttributes, profile]);

  return {
    bookmarkedAttributes,
    hasBookmarkedAttributes,
    userCustomFields,
  };
};
